/* カスタマイズ用JS */

document.addEventListener(
  "DOMContentLoaded",
  function () {

    // 説明部分のモーダル化機能追記
    const openCustomContactFormModal = () => {

      // 「詳しく見る」ボタンのすべての要素を取得
      const open_btn = document.getElementById("custom-contact__modal-open-button");
      const modal = document.getElementById("custom-contact__modal");

      if (open_btn.length === 0 || modal.length === 0) return;

      // 各要素にイベントリスナーを追加
      open_btn.addEventListener("click", function () {
        // モーダル表示
        modal.style.display = "block";
      });

      // 閉じるボタンクリック時にモーダル閉じる
      document.getElementById("custom-contact__modal-close").onclick = (e) => {
        modal.style.display = "none";
      };

      // モーダルコンテンツ外がクリックされたとき、モーダル閉じる
      modal.addEventListener("click", (e) => {
        if (!e.target.closest(".custom-contact__modal-body")) {
          modal.style.display = "none";
        }
      });
    };

    // 実行
    openCustomContactFormModal();
  },
  false
);
